import { Themes } from '@palmetto/dsm-tokens';
import classNames from 'classnames';
export interface DataCollectionProps {
  heading: string;
  descr?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  theme?: keyof typeof Themes;
}

export const DataCollection = (props: DataCollectionProps) => {
  const { heading, descr, children, className, theme } = props;

  return (
    <div
      {...(theme && { 'data-theme': theme })}
      className={classNames(
        'bg-canvas-default px-24 py-64 md:p-64 flex flex-col gap-24 min-h-full md:justify-center max-w-full rounded-20',
        className,
      )}
    >
      <h1 className="heading-700 text-text-primary">{heading}</h1>
      {descr && <div className="body-400 text-text-secondary">{descr}</div>}
      <div>{children}</div>
    </div>
  );
};
